import script from "./file-input.vue?vue&type=script&setup=true&lang=js"
export * from "./file-input.vue?vue&type=script&setup=true&lang=js"

import "./file-input.vue?vue&type=style&index=0&id=2c0b43b0&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c0b43b0"]])

export default __exports__